import { NoddiBasicCard, NoddiSkeleton } from 'noddi-ui-web';

type Props = {
  rowCount?: number;
};

/** Placeholder in the shape of `ProposalRow` so the list keeps its footprint while it loads. */
export const ProposalRowsSkeleton = ({ rowCount = 3 }: Props) => (
  <NoddiBasicCard className='flex flex-col divide-y divide-border overflow-hidden p-0'>
    {Array.from({ length: rowCount }, (_, index) => (
      <div
        key={index}
        className='flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between md:gap-5 md:px-5'
      >
        <div className='flex flex-col gap-2'>
          <NoddiSkeleton variant='button' className='h-4 w-52 max-w-full' />
          <NoddiSkeleton variant='button' className='h-3 w-32' />
        </div>
        <div className='flex items-center justify-between gap-4 md:justify-end'>
          <NoddiSkeleton variant='button' className='h-4 w-20' />
          <NoddiSkeleton variant='button' className='h-8 w-24' />
        </div>
      </div>
    ))}
  </NoddiBasicCard>
);
